export default function References() {
  return (
    <div className="max-w-4xl mx-auto p-10">
      <h1 className="text-2xl font-semibold mb-3">References</h1>

      <ul className="text-gray-600 space-y-3">
        <li>
         Standardising human endogenous retrovirus analyses:
Challenges and a primer-assay database
Jo˜ao P. C. R. de Mendon¸ca Emilie Sofie Engdal Mauricio Moldes
Kristoffer Staal Rohrberg Peter Johannes Holst Frederik Otzen Bagger
        </li>
        <li>
          Subramanian et al. (2011) Endogenous retrovirus expression in human disease.
        </li>
        <li>
          Bannert & Kurth (2006) Retroelements and the human genome.
        </li>
      </ul>
    </div>
  );
}